import { render, staticRenderFns } from "./RowSwitch.vue?vue&type=template&id=09a66d91&scoped=true"
import script from "./RowSwitch.vue?vue&type=script&lang=js"
export * from "./RowSwitch.vue?vue&type=script&lang=js"
import style0 from "./RowSwitch.vue?vue&type=style&index=0&id=09a66d91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a66d91",
  null
  
)

export default component.exports